import { Stack, Typography } from "@mui/material";
import { SpousalMaintenanceFieldVisibility, SpousalMaintenanceFormValues, SpousalMaintenanceInputs } from "@shared";
import { FormikProps } from "formik";

import { useTranslation } from "@/translations";

import { TRANSLATION_BASE } from "../SpousalMaintenanceCalculatorDialog.utils";

interface SpousalMaintenanceCalculatorInputsProps {
  formik: FormikProps<SpousalMaintenanceFormValues>;
  visibility: SpousalMaintenanceFieldVisibility;
}

export function SpousalMaintenanceCalculatorInputs({ formik, visibility }: SpousalMaintenanceCalculatorInputsProps) {
  const { t } = useTranslation();

  return (
    <Stack flex={1} gap={3} py={2}>
      <Typography variant="overline" color="text.secondary">
        {t(`${TRANSLATION_BASE}.inputsTitle`)}
      </Typography>

      {/* The dead-end "nicht verheiratet" message is rendered in the result panel instead. */}
      <SpousalMaintenanceInputs formik={formik} visibility={visibility} showNotMarriedMessage={false} />
    </Stack>
  );
}
